  "use client"

  import { useState, useEffect, useRef, useCallback } from "react"
  import { useParams,useNavigate } from "react-router-dom"
  import useSWR from "swr"
  import { toast, ToastContainer } from "react-toastify"
  import "react-toastify/dist/ReactToastify.css"

  const fetcher = (url) => fetch(url).then((res) => res.json())

  export default function VendorEdit() {
    const { id } = useParams()
    const module = "Logistic_Request"

  // inside your component
  const navigate = useNavigate();
    const [formData, setFormData] = useState({})
    const [sections, setSections] = useState([])
    const [options, setOptions] = useState({})
    const labelToApiNameMap = useRef({})
    const [loading, setLoading] = useState(false)


    const { data, error } = useSWR(
      () => module ? `/server/dealer_backend/getLayout?module=${module}` : null,
      fetcher
    )

    console.log({data})


    useEffect(() => {
      if (!data || error) return

      if (data.status === "success") {
        const layout = data?.data.find((layout) => layout.layout_name === "Standard")
        if (!layout) return

        const allowedSections = ["Logistic Request Information", "Pickup Details", "Dispatch Details","Remarks"]
        const allowedFieldsInMainSection = ["Request Type", "Request Status", "Description"]

        const usableSections = layout.sections
          .filter(
            (section) =>
              allowedSections.includes(section.display_label) &&
              Array.isArray(section.fields) &&
              section.fields.some((f) => f.type === "used")
          )
          .map((section) => {
            // Special case: filter fields in "Logistic Request Information"
            if (section.display_label === "Logistic Request Information") {
              return {
                ...section,
                fields: section.fields.filter(
                  (f) => allowedFieldsInMainSection.includes(f.display_label)
                ),
              }
            }

            // For Pickup, keep all used fields
            if (section.display_label === "Pickup Details") {
              return {
                ...section,
                fields: section.fields.filter((f) => f.type === "used"),
              }
            }

            // For Dispatch, only show Expected Delivery Date
            if (section.display_label === "Dispatch Details") {
              return {
                ...section,
                fields: section.fields.filter((f) => f.display_label === "Expected Delivery Date"),
              }
            }

            return section
          })
          .filter((section) => section.fields.length > 0)


        setSections(usableSections)

        // map labels → api names
        const map = {}
        usableSections.forEach((s) =>
          s.fields.forEach((f) => {
            map[f.display_label] = f.name
          })
        )
        labelToApiNameMap.current = map
      }
    }, [data, error])


    const { data: vendorData, error: vendorError } = useSWR(
      id ? `/server/dealer_backend/getSpecificVendorLogic?id=${id}` : null,
      fetcher
    )

    // ✅ Once vendor data loads, set it to formData
    useEffect(() => {
      if (vendorData?.status === "success" && vendorData?.data?.[0]) {
        setFormData(vendorData.data[0]) // pre-fill with backend data
      }
    }, [vendorData])
    // picklist values fetch
    const fetchPickListValues = async (id) => {
      try {
        const response = await fetch(
          `/server/dealer_backend/getPickListValues/${id}?module=${module}`
        )
        const resData = await response.json()
        if (resData.status === "success") {
          setOptions((prev) => ({
            ...prev,
            [id]: resData?.data,
          }))
        }
      } catch (err) {
        console.error("Picklist fetch failed:", err)
      }
    }

    useEffect(() => {
      sections.forEach((s) =>
        s.fields.forEach((f) => {
          if (f?.data_type === "picklist" && f.id) {
            fetchPickListValues(f.id)
          }
        })
      )
    }, [sections])

    const handleInputChange = useCallback((name, value) => {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }))
    }, [])

     const handleSave = async (e) => {
  e.preventDefault();
  setLoading(true);

  // show toast loader
  const toastId = toast.loading("Saving vendor details...");

  const requestBody = {
    data: [formData],
  };

  try {
    const response = await fetch(`/server/dealer_backend/edit-vendors/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestBody),
    });

    const result = await response.json();

    if (result.status === "success") {
      toast.update(toastId, {
        render: "Vendor updated successfully!",
        type: "success",
        isLoading: false,
        autoClose: 1500,
      });

      setTimeout(() => {
        navigate(`/vendor-details/${id}`);
      }, 1600);
    } else {
      toast.update(toastId, {
        render: "Failed to update vendor!",
        type: "error",
        isLoading: false,
        autoClose: 2000,
      });
      console.error("Error updating vendor:", result.error);
    }
  } catch (error) {
    toast.update(toastId, {
      render: "An error occurred while updating vendor!",
      type: "error",
      isLoading: false,
      autoClose: 2000,
    });
    console.error("Error submitting update:", error);
  } finally {
    setLoading(false);
  }
};

    
    
    const renderField = (field) => {
      const value = formData[field.name] || ""

      switch (field.data_type) {
        case "text":
        case "email":
        case "phone":
          return (
            <input
              style={styles.input}
              type={field.data_type === "email" ? "email" : field.data_type === "phone" ? "tel" : "text"}
              value={value}
              onChange={(e) => handleInputChange(field.name, e.target.value)}
            />
          )

        case "textarea":
          return (
            <textarea
              style={styles.textarea}
              value={value}
              onChange={(e) => handleInputChange(field.name, e.target.value)}
            />
          )

        case "date":
          return (
            <input
              style={styles.input}
              type="date"
              value={value ? value.split("T")[0] : ""}
              onChange={(e) => handleInputChange(field.name, e.target.value)}
            />
          )

        case "datetime":
          return (
            <input
              style={styles.input}
              type="datetime-local"
              value={value ? value.slice(0, 16) : ""}
              onChange={(e) => handleInputChange(field.name, e.target.value)}
            />
          )

        case "integer":
        case "bigint":
          return (
            <input
              style={styles.input}
              type="number"
              value={value}
              onChange={(e) => handleInputChange(field.name, e.target.value)}
            />
          )

        case "boolean":
          return (
            <input
              style={styles.checkbox}
              type="checkbox"
              checked={!!value}
              onChange={(e) => handleInputChange(field.name, e.target.checked)}
            />
          )

        case "picklist":
          const picklistValues = options[field.id] || []
          return (
            <select
              style={styles.select}
              value={value}
              onChange={(e) => handleInputChange(field.name, e.target.value)}
            >
              <option value="">Select option</option>
              {picklistValues.map((opt, idx) => (
                <option key={idx} value={opt}>
                  {opt}
                </option>
              ))}
            </select>
          )

        default:
          return (
            <input
              style={styles.input}
              value={value}
              onChange={(e) => handleInputChange(field.name, e.target.value)}
            />
          )
      }
    }

    return (
      <div style={styles.container}>
        {/* <ToastContainer position="top-right" autoClose={2000} /> */}
        {/* Header */}
        <div style={styles.header}>
          <div style={styles.headerContent}>
            <div style={styles.headerLeft}>
              <button
                style={{ ...styles.button, ...styles.secondaryButton }}
                onClick={() => navigate(`/vendor-details/${id}`)}
              >
                ←
              </button>
              <div style={styles.headerLeft}>
                {/* <div style={styles.avatar}></div> */}
                <span style={{ fontWeight: "500" }}>Edit Logistic Request</span>
              </div>
            </div>
            <div style={{ display: "flex", gap: "8px" }}>
              <button
  style={{ ...styles.button, ...styles.primaryButton, opacity: loading ? 0.6 : 1 }}
  onClick={handleSave}
  disabled={loading}
>
  {loading ? "Saving..." : "💾 Save"}
</button>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div style={styles.mainContent}>
          {sections.map((section, idx) => {
            // conditional rendering for pickup/dispatch
            // Filter Pickup and Dispatch sections based on exact match
            if (
              (section.display_label === "Pickup Details" && formData.Request_Type !== "Pickup") ||
              (section.display_label === "Dispatch Details" && formData.Request_Type !== "Dispatch")
            ) {
              return null
            }


            return (
              <div key={idx} style={styles.card}>
                <div style={styles.cardHeader}>
                  <h2 style={styles.cardTitle}>{section.display_label}</h2>
                </div>
                <div style={styles.cardContent}>
                  <div style={{ ...styles.grid, ...styles.gridCols2 }}>
                    {section.fields.map((field, fIdx) => (
                      <div key={fIdx} style={styles.fieldGroup}>
                        <label style={styles.label}>{field.display_label}</label>
                        {renderField(field)}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )
          })}
        </div>
        
      </div>
    )
  }

  // Custom styles object for basic React styling
  const styles = {
    container: {
      minHeight: "100vh",
      backgroundColor: "#f9fafb",
    },
    header: {
      backgroundColor: "#14b8a6",
      color: "white",
      padding: "16px",
    },
    headerContent: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      maxWidth: "1280px",
      margin: "0 auto",
    },
    headerLeft: {
      display: "flex",
      alignItems: "center",
      gap: "16px",
    },
    avatar: {
      width: "32px",
      height: "32px",
      backgroundColor: "#5eead4",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "14px",
      fontWeight: "600",
    },
    button: {
      padding: "8px 16px",
      borderRadius: "6px",
      border: "none",
      cursor: "pointer",
      fontSize: "14px",
      fontWeight: "500",
      display: "flex",
      alignItems: "center",
      gap: "8px",
    },
    primaryButton: {
      backgroundColor: "white",
      color: "#14b8a6",
      border: "1px solid #e5e7eb",
    },
    secondaryButton: {
      backgroundColor: "transparent",
      color: "white",
      border: "1px solid rgba(255,255,255,0.3)",
    },
    outlineButton: {
      backgroundColor: "white",
      color: "#374151",
      border: "1px solid #d1d5db",
    },
    deleteButton: {
      backgroundColor: "white",
      color: "#dc2626",
      border: "1px solid #fecaca",
    },
    mainContent: {
      maxWidth: "1280px",
      margin: "0 auto",
      padding: "24px",
      display: "flex",
      flexDirection: "column",
      gap: "24px",
    },
    card: {
      backgroundColor: "white",
      borderRadius: "8px",
      border: "1px solid #e5e7eb",
      boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1)",
    },
    cardHeader: {
      padding: "20px 24px 16px",
      borderBottom: "1px solid #f3f4f6",
    },
    cardTitle: {
      fontSize: "18px",
      fontWeight: "600",
      color: "#1f2937",
    },
    cardContent: {
      padding: "24px",
    },
    grid: {
      display: "grid",
      gap: "16px",
    },
    gridCols2: {
      gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
    },
    fieldGroup: {
      display: "flex",
      flexDirection: "column",
      gap: "8px",
    },
    label: {
      fontSize: "14px",
      fontWeight: "500",
      color: "#374151",
    },
    input: {
      padding: "8px 12px",
      border: "1px solid #d1d5db",
      borderRadius: "6px",
      fontSize: "14px",
      outline: "none",
      transition: "border-color 0.2s",
      width:"32%"
    },
    textarea: {
      padding: "8px 12px",
      border: "1px solid #d1d5db",
      borderRadius: "6px",
      fontSize: "14px",
      outline: "none",
      resize: "vertical",
      minHeight: "80px",
    },
    select: {
      padding: "8px 12px",
      border: "1px solid #d1d5db",
      borderRadius: "6px",
      fontSize: "14px",
      outline: "none",
      backgroundColor: "white",
    },
    checkbox: {
      width: "16px",
      height: "16px",
      accentColor: "#14b8a6",
    },
    subformItem: {
      padding: "16px",
      border: "1px solid #e5e7eb",
      borderRadius: "8px",
      display: "flex",
      flexDirection: "column",
      gap: "16px",
    },
    subformHeader: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },
    subformTitle: {
      fontSize: "16px",
      fontWeight: "500",
      color: "#1f2937",
    },
  }